import React from 'react';
import * as DateFns from 'date-fns';

import { USE_IN_PROGRESS_COMPS_DAYS } from '../../../../../../config/constants';
import { SmallMonthRowsPropsType } from '../../types';

import './styles.scss';

const SmallMonthRows = ({ monthShown, selectedDates, click, newData, currentDate }: SmallMonthRowsPropsType) => {
  const startDate = DateFns.startOfWeek(DateFns.startOfMonth(monthShown));
  const endDate = DateFns.endOfWeek(DateFns.endOfMonth(monthShown));
  const rows = [];
  const NUMBER_OF_WEEK_DAYS = 7;
  let days = [];
  let day = startDate;
  while (day <= endDate) {
    for (let i = 0; i < NUMBER_OF_WEEK_DAYS; i++) {
      const copyDay = day;
      days.push(
        <div
          className={`small-month-row-cell ${
            selectedDates.some((date) => (DateFns.isSameDay(copyDay, date.start) || DateFns.isSameDay(copyDay, date.end))) ?
              'small-month-row-cell-selected ' :
              (!DateFns.isSameMonth(day, monthShown) || (newData.isUseInProgressComps && !DateFns.isWithinInterval(copyDay, {
                start: DateFns.subDays(currentDate, USE_IN_PROGRESS_COMPS_DAYS),
                end: currentDate
              }))) ?
                'small-month-row-cell-disabled ' :
                ''} ${selectedDates.some((date) => (DateFns.isWithinInterval(copyDay, {
            start: date.start,
            end: date.end
          }))) ?
            'small-month-row-cell-selected-in ' : ''}`}
          key={day.toString()}
          onClick={() => (click(copyDay))}
        >
          {DateFns.format(new Date(day), 'd')}
          {/* <label className="calendar-point"/> */}
        </div>
      );
      day = DateFns.addDays(day, 1);
    }
    rows.push(<div className="small-month-row" key={day.toString()}>{days}</div>);
    days = [];
  }
  return <div>{rows}</div>;
};

export default SmallMonthRows;
